export default __webpack_public_path__ + "static/satin-2-dead882030535943b5ec75a1f976b5fa.jpg";